export const ASSET_TYPE = {
	APK: 'apk',
	IMAGE: 'image',
	MEDIA_PUBLIC: 'mediaPublic',
	MEDIA_PRIVATE: 'mediaPrivate',
	MEDIA_PRIVATE_PDF: 'pdf',
	CSV: 'csv',
	ALL: 'all',
	MEME: 'meme',
	THUMBNAIL: 'thumbnail',
	SPOTLIGHT_VIDEO: 'spotlightVideo',
	LAUNCH_VIDEO: 'launchWidgetVideo',
	MISC_ASSET: 'miscAsset',
	EXCEL: 'xlsx'
};

export const FORM_DATA_NAME = {
	[ASSET_TYPE.APK]: 'apk',
	[ASSET_TYPE.IMAGE]: 'image',
	[ASSET_TYPE.MEDIA_PUBLIC]: 'uploaded_file',
	[ASSET_TYPE.MEDIA_PRIVATE]: 'uploaded_file',
	[ASSET_TYPE.CSV]: 'csv',
	[ASSET_TYPE.MEDIA_PRIVATE_PDF]: 'uploaded_file',
	[ASSET_TYPE.MEME]: 'image',
	[ASSET_TYPE.THUMBNAIL]: 'image',
	[ASSET_TYPE.LAUNCH_VIDEO]: 'video',
	[ASSET_TYPE.SPOTLIGHT_VIDEO]: 'video',
	[ASSET_TYPE.MISC_ASSET]: 'uploaded_file'
};

export type AssetType =
	| 'apk'
	| 'image'
	| 'mediaPublic'
	| 'mediaPrivate'
	| 'csv'
	| 'all'
	| 'kyc'
	| 'pdf'
	| 'meme'
	| 'thumbnail'
	| 'spotlightVideo'
	| 'miscAsset';

export interface useAssetUploadOnS3Props {
	value: any;
	onChange: any;
	setShowLoader: (value: boolean) => void;
	assetType: AssetType;
	multiple: boolean;
	maxFileSizeMB?: number;
	subFolder?: string;
	zupeeUserId?: number;
	handleFileUpload?: boolean;
	usePresignedUrl?: boolean;
}

export interface AssetUploadOnS3Props {
	onChange: any;
	value: any;
	disabled?: any;
	setShowLoader: any;
	assetType: AssetType;
	multiple?: boolean;
	downloadFile?: boolean;
	link?: string;
	displayText?: string;
	maxFileSizeMB?: number;
	subFolder?: string;
	zupeeUserId?: number;
	usePresignedUrl?: boolean;
}

export const END_POINT = {
	[ASSET_TYPE.IMAGE]: '/marketing/dashboard/banner/uploadImage',
	[ASSET_TYPE.APK]: '/marketing/dashboard/apk/uploadApk',
	[ASSET_TYPE.MEDIA_PRIVATE]: '/dashboard/unauthorized/uploadPrivateFile',
	[ASSET_TYPE.MEDIA_PUBLIC]: '/dashboard/unauthorized/uploadPublicFile',
	[ASSET_TYPE.CSV]: '/marketing/dashboard/wallet/uploadCsv',
	[ASSET_TYPE.MEDIA_PRIVATE_PDF]: '/dashboard/unauthorized/uploadPrivateFile',
	[ASSET_TYPE.MEME]: '/marketing/dashboard/social/getMemeUploadPreSignedUrl',
	[ASSET_TYPE.THUMBNAIL]: '/marketing/dashboard/social/getPreSignedUrl',
	[ASSET_TYPE.LAUNCH_VIDEO]: '/marketing/dashboard/notices/getLaunchPreSignedUrl',
	[ASSET_TYPE.SPOTLIGHT_VIDEO]: '/marketing/dashboard/social/getPreSignedUrl',
	[ASSET_TYPE.MISC_ASSET]: '/marketing/dashboard/utilities/getMiscAssetUploadPreSignedUrl'
	// [ASSET_TYPE.KYC_DOC]: 'crm/userDetails/kycDetails/getKycSignedUrl'
};

export const ACCEPTED_FILE_TYPES = {
	[ASSET_TYPE.IMAGE]: 'image/*',
	// [ASSET_TYPE.KYC_DOC]: 'image/*',
	[ASSET_TYPE.APK]: '.apk',
	[ASSET_TYPE.MEDIA_PRIVATE]: '*/*',
	[ASSET_TYPE.MEDIA_PUBLIC]: '*/*',
	[ASSET_TYPE.ALL]: '*/*',
	[ASSET_TYPE.CSV]: '.csv',
	[ASSET_TYPE.MEDIA_PRIVATE_PDF]: '.pdf',
	[ASSET_TYPE.MEME]: 'image/*',
	[ASSET_TYPE.THUMBNAIL]: 'image/*',
	[ASSET_TYPE.LAUNCH_VIDEO]: 'video/*',
	[ASSET_TYPE.SPOTLIGHT_VIDEO]: 'video/*',
	[ASSET_TYPE.MISC_ASSET]: '*/*'
};

export const URL_NAME = {
	[ASSET_TYPE.IMAGE]: 'imageUrl',
	// [ASSET_TYPE.KYC_DOC]: 'imageUrl',
	[ASSET_TYPE.APK]: 'apkLinkUrl',
	[ASSET_TYPE.MEDIA_PRIVATE]: 'fileUrl',
	[ASSET_TYPE.MEDIA_PUBLIC]: 'fileUrl',
	[ASSET_TYPE.CSV]: 'fileUrl',
	[ASSET_TYPE.MEDIA_PRIVATE_PDF]: 'fileUrl',
	[ASSET_TYPE.MEME]: 'signedUrl',
	[ASSET_TYPE.THUMBNAIL]: 'signedUrl',
	[ASSET_TYPE.LAUNCH_VIDEO]: 'signedUrl',
	[ASSET_TYPE.SPOTLIGHT_VIDEO]: 'signedUrl',
	[ASSET_TYPE.MISC_ASSET]: 'signedUrl'
};
